import React from 'react';
import { useNavigate } from 'react-router-dom';
import CreateProduct from '../components/products/CreateProduct';

const UploadProductPage = () => {
  const navigate = useNavigate();

  const handleProductCreated = () => {
    navigate('/wallet');
  };

  return (
    <div className="min-h-screen bg-white py-8 px-2">
      <CreateProduct onProductCreated={handleProductCreated} />
    </div>
  );
};

export default UploadProductPage;
